export default {
  default: () => import("/builds/rezonova/3ifafr-website/front/layouts/default.vue"),
  fullpage: () => import("/builds/rezonova/3ifafr-website/front/layouts/fullpage.vue"),
  pdfpage: () => import("/builds/rezonova/3ifafr-website/front/layouts/pdfpage.vue")
}